import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getData } from '../../../app/getters/getData.js'

export const useRegon = (regon, mode, enabled = false) => {
    const role = useSelector((state) => state.user.role)
    const target = mode === 'test' ? 'test' : mode === 'data' ? 'regon' : ''
    const prefix = role === 'oper' ? 'oper/' : ''
    const canFetch = Boolean(regon) && Boolean(target)

    return useQuery({
        queryKey: ['regon', role, regon, target],
        queryFn: () => getData(`${prefix}profile/${regon}/${target}`),
        enabled: enabled && canFetch,
        refetchOnMount: 'always',
    })
}
